"use strict";
exports.__esModule = true;
exports.SvgFlagFill = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgFlagFill = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { d: "M0 0h14v14H0z" }),
        react_1["default"].createElement("path", { fill: "#D14424", d: "M2.778 1c.43 0 .778.336.778.75V2h7.922a.51.51 0 01.518.5.49.49 0 01-.069.249L10.3 5.485l1.633 2.768a.49.49 0 01-.194.682.545.545 0 01-.257.065H3.556v3.25c0 .414-.348.75-.778.75A.764.764 0 012 12.25V1.75c0-.414.348-.75.778-.75z" })))); };
//# sourceMappingURL=FlagFill.js.map